import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRightIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.882 4.589 C 13.563 4.747,13.406 5.106,13.500 5.462 C 13.544 5.628,13.813 5.911,16.346 8.448 L 19.144 11.250 11.731 11.250 L 4.318 11.250 4.135 11.338 C 3.588 11.603,3.588 12.397,4.135 12.662 L 4.318 12.750 11.731 12.750 L 19.144 12.750 16.346 15.552 C 13.813 18.089,13.544 18.372,13.500 18.538 C 13.440 18.764,13.475 18.974,13.604 19.172 C 13.710 19.334,13.998 19.500,14.175 19.500 C 14.522 19.500,14.391 19.619,18.076 15.943 C 20.008 14.015,21.616 12.387,21.649 12.325 C 21.726 12.180,21.725 11.820,21.649 11.675 C 21.616 11.613,20.027 10.002,18.117 8.095 C 15.679 5.659,14.600 4.609,14.491 4.564 C 14.278 4.476,14.095 4.484,13.882 4.589 ",
		stroke: "none",
		fillRule: "evenodd",
		fill: "currentColor"
	})
});
export default SvgArrowRightIcon;
